import { useEffect, useState, useMemo } from "react";
import { SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import CONFIG from "../../../utils/config";
import {
  getCoeRea,
  getCoeOffices,
  getCoeManagers,
  getCoeTrendCurve,
  usageReport,
  getSavedFilterDataResponseClearById,
  getSavedFilterDataById,
  usageReportClear,
  getLearningPathSurveyReportTableData,
  getLearningPathSurveyReportTableDataResClear,
} from "../../../redux/reports/actions";
import _, { sortBy } from "lodash";

import { useNavigate, useLocation } from "react-router-dom";

import Loader from "../../Loader/Loader";
import ReportHeaderComponent from "../layout/ReportHeaderComponent";
import ReportExportButtonComponent from "../layout/ReportExportButtonComponent";
import ReportFiltersComponent from "../layout/ReportFiltersComponent";
import * as XLSX from "xlsx";
import { isAndroid, isIOS } from "react-device-detect";
import ConfirmModal from "../../modal/ConfirmModal";
import LPSurveyTableComp from "../ReportsComponents/LPSurveyTableComp";
import axios from "axios";
import API_LIST from "../../../utils/apiList";
import StaticUtils from "../../../utils/StaticUtils";
import moment from "moment";
const LearningPathSurveyReportHomeSection = (props) => {
  const { isMobile } = props;

  let location = useLocation();

  console.log("state---", location.state?.selectedFilters); // Access the state

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const filterId = params.get("filters_id");
  const backbutton = params.get("backbutton");
  const authBroker = useSelector((state) => state.auth.authBroker);
  const authIframeBroker = useSelector((state) => state.auth.authIframeBroker);

  const [savedFiltersDataById, setSavedFiltersDataById] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const fileName = "SystemUsageReport";
  const [confirmModal, setConfirmModal] = useState(false);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [filterYearData, setFilterYearData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [imgLoader, setImgLoader] = useState(true);
  const [reaList, setReaList] = useState([]);
  const [limitStatus, setLimitStatus] = useState("");
  const [loadSpin, setLoadSpin] = useState(true);
  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Progress" },
  ];

  const [statusFilterData] = useState([
    "Completed",
    "In Progress",
    "NotStarted",
  ]);
  const [profileReports, setProfileReports] = useState([]);
  const [totalRea, setTotalRea] = useState([]);
  const [profileReportsFilter, setProfileReportsFilter] = useState([]);

  // const profileReportRes = useSelector((state) => state.report?.profileReport);
  const usageReportRes = useSelector(
    (state) => state?.report?.surveyReportData
  );
  const d = new Date();
  let year = d.getFullYear();
  const [trendYear, setTrendYear] = useState(year);
  const anyTotalReportRes = useSelector(
    (state) => state.report?.anyTotalReport
  );
  const coeReaSectRes = useSelector((state) => state.report?.coeReportRea);

  const coeOfficesSectRes = useSelector(
    (state) => state.report?.coeReportOffices
  );
  const coeTrendCurveRes = useSelector((state) => state.report?.coeTrend);
  // const crsCompletionTrendRes = useSelector(
  //   (state) => state.report.complianceCompletionTrend
  // );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  const [counter, setCounter] = useState(1);
  const [officeCounter, setOfficeCounter] = useState(1);
  const [managerCounter, setManagerCounter] = useState(1);
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [totalCountRea, setTotalCountRea] = useState("");
  const [showModalMsg, setShowModalMsg] = useState(
    "Available Real Estate Agents limit reached!"
  );
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const userDetailIframe = useSelector((state) => state.user.userDetailIframe);
  const [userDetails, setUserDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isExpand, setIsExpand] = useState(false);
  const [localFilters, setLocalFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({
    dateRange: { start: "", end: "" },
    selectedProviderList: [],
    selectedOfficeList: [],
    selectedManagerCoachList: [],
    check: false,
    selectedCourseList: [],
    selectedTeamMatesList: [],
    selectedRole: [],
    selectedAgentStatus: [1],
    clickedApply: false,
    selectedSurveyList: [],
  });
  const [showFilters, setShowFilters] = useState({
    reportingPeriod: false,
    provider: false,
    offices: true,
    role: true,
    reportingTo: true,
    learningContentType: false,
    learningContent: true,
    agents: true,
    status: true,
    dojBrokerage: false,
    agentStatus: false,
    roleFilter: {
      manager: true,
      guest: true,
      all: true,
      instructor: false,
      SystemUsageReports: false,
      rea: true,
    },
    assignmentFrom: false,
    survey: true,
    surveyStatus: true,
  });
  const [reaIds, setReaIds] = useState([]);
  const [officeIds, setOfficeIds] = useState([]);
  const [managerIds, setManagerIds] = useState([]);
  const [surveyIds, setSurveyIds] = useState([]);
  const [lpSurveyIds, setLpSurveyIds] = useState([]);
  const [statusAPI, setStatusAPI] = useState([
    "completed",
    "in-progress",
    "not-started",
  ]);
  const [Role, setRole] = useState(["realtor", "manager", "guest", "all"]);
  const [dojRange, setdojRange] = useState({ start: "", end: "" });
  const [officeLabel, setOfficeLabel] = useState("");
  const [pageNum, setPageNum] = useState(0);
  const [progressSort, setProgressSort] = useState("asc");
  const [searchInput, setSearchInput] = useState("");
  const [pageSize, setPageSize] = useState(50);

  const rea_ids = [];
  const manager_ids = [];
  const office_ids = [];
  const courseList = [];
  const providerList = [];
  const [userStatusFilter, setUserStatusFilter] = useState(1);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (
        !_.isEmpty(authBroker.payload?.user?.config) &&
        authBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authBroker]);

  useEffect(() => {
    console.log(
      "selectedFilters: ",
      selectedFilters,
      !filterId,
      !localStorage.getItem("SELECTED_FILTER")
    );

    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if (
        (authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate) &&
        false
      ) {
      } else if (
        (!_.isEmpty(selectedFilters) &&
          !filterId &&
          !localStorage.getItem("SELECTED_FILTER")) ||
        selectedFilters?.clickedApply
      ) {
        setTimeout(() => {
          setReaList([]);
          getTableReport();
          setPageNum(0);
        }, 1000);
        localStorage.removeItem("SELECTED_FILTER");
      } else if (localStorage.getItem("SELECTED_FILTER")) {
        console.log(
          "selected filters----",
          JSON.parse(localStorage.getItem("SELECTED_FILTER"))
        );
        const filterData = JSON.parse(localStorage.getItem("SELECTED_FILTER"));
        if (!filterData.isLP) {
          setSelectedFilters(filterData.selectedFilters);
          setLocalFilters(filterData.selectedFilters);
          setIsExpand(true);
        } else {
          setReaList([]);
          getTableReport();
          localStorage.removeItem("SELECTED_FILTER");
        }
      }
    }
  }, [selectedFilters, authBroker, authIframeBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
      if (
        !_.isEmpty(authIframeBroker.payload?.user?.config) &&
        authIframeBroker.payload?.user?.config.office_name
      ) {
        setOfficeLabel(authIframeBroker.payload?.user?.config.office_name);
      } else {
        setOfficeLabel("Office Name");
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      if (authBroker.status === "success") {
        if (authBroker.payload && authBroker.payload?.user) {
          if (authBroker.payload?.user?.is_corporate) {
            setShowFilters({
              reportingPeriod: false,
              provider: false,
              offices: true,
              role: true,
              reportingTo: true,
              learningContentType: false,
              learningContent: true,
              agents: true,
              status: true,
              dojBrokerage: false,
              agentStatus: false,
              roleFilter: {
                manager: true,
                guest: true,
                all: true,
                instructor: false,
                SystemUsageReports: false,
                rea: true,
              },
              survey: true,
              surveyStatus: true,
            });
            // setIsExpand(true)
          }
        }
      }
    }
  }, [authBroker]);

  useEffect(() => {
    if (!_.isEmpty(authIframeBroker)) {
      if (authIframeBroker.payload && authIframeBroker.payload?.user) {
        if (authIframeBroker.payload?.user?.is_corporate) {
          setShowFilters({
            reportingPeriod: false,
            provider: false,
            offices: true,
            role: true,
            reportingTo: true,
            learningContentType: false,
            learningContent: true,
            agents: true,
            status: true,
            dojBrokerage: false,
            agentStatus: false,
            roleFilter: {
              manager: true,
              guest: true,
              all: true,
              instructor: false,
              SystemUsageReports: false,
              rea: true,
            },
            survey: true,
            surveyStatus: true,
          });
          // setIsExpand(true)
        }
      }
    }
  }, [authIframeBroker]);

  useEffect(() => {
    console.log("ss-- loc", savedFiltersDataById?.filter_content);
    if (!_.isEmpty(savedFiltersDataById?.filter_content)) {
      setIsLoading(true);

      let reaIds =
        savedFiltersDataById?.filter_content.selectedTeamMatesList.map(
          (obj) => {
            return obj.user_id;
          }
        );

      let officeIds =
        savedFiltersDataById?.filter_content.selectedOfficeList.map((obj) => {
          console.log("GET OFFICE IDS get", obj);
          return obj.office_id;
        });

      let managerIds =
        savedFiltersDataById?.filter_content.selectedManagerCoachList.map(
          (obj) => {
            return obj.id;
          }
        );
      let lpSurveyIds =
        savedFiltersDataById?.filter_content.selectedProviderList.map((obj) => {
          return obj.id;
        });

      let userStatus = 4;
      if (_.isArray(savedFiltersDataById?.filter_content.selectedAgentStatus)) {
        if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
            3
          ) ||
          (savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
            1
          ) &&
            savedFiltersDataById?.filter_content.selectedAgentStatus.includes(
              2
            ))
        ) {
          userStatus = 3;
        } else if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(1)
        ) {
          userStatus = 1;
        } else if (
          savedFiltersDataById?.filter_content.selectedAgentStatus.includes(2)
        ) {
          userStatus = 2;
        }
      }
      setUserStatusFilter(userStatus);
      dispatch(
        usageReport({
          module: "getUsageReport",
          postData: {
            token: isMobile
              ? localStorage.getItem(SessionKeys.API_TOKEN)
              : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            rea_ids: reaIds,
            office_ids: officeIds,
            manager_ids: managerIds,
            role: savedFiltersDataById?.filter_content.selectedRole,
            search: "",
            page: "",
            page_size: "",
            date_range: savedFiltersDataById?.filter_content?.dojRange,
            user_status: userStatus,
          },
        })
      );
    }
  }, [savedFiltersDataById]);

  useEffect(() => {
    if (filterId) {
      getSavedFiltersDataByIdFunc();
    }
    return () => {
      dispatch(getSavedFilterDataResponseClearById());
    };
  }, [filterId]);

  const getSavedFiltersDataByIdFunc = () => {
    setIsLoading(true);
    dispatch(
      getSavedFilterDataById({
        module: "getSavedFiltersDataById",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: filterId,
        },
      })
    );
  };

  const getSavedFiltersDataResponseById = useSelector(
    (state) => state.report.savedFilterDataById
  );

  useEffect(() => {
    if (!_.isEmpty(getSavedFiltersDataResponseById)) {
      if (getSavedFiltersDataResponseById?.status === "success") {
        setSavedFiltersDataById(
          getSavedFiltersDataResponseById?.payload?.payload[0]
        );
      } else {
        setSavedFiltersDataById("");
      }
    }
  }, [getSavedFiltersDataResponseById]);

  useEffect(() => {
    console.log("ss-- dispatch", !filterId);
    if (
      ((!filterId || selectedFilters?.clickedApply) &&
        (authBroker.payload?.user || authIframeBroker.payload?.user) &&
        !(
          authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate
        )) ||
      true
    ) {
      loadAllApi();
    }
    // }
  }, [dispatch]);

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload);
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload);
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile]);

  useEffect(() => {
    console.log(selectedFilters);
  }, [selectedFilters]);
  useEffect(() => {
    console.log("GET OFFICE IDS - ", officeIds);
  }, [officeIds]);

  let PageSize = 20;

  useEffect(() => {
    console.log("selected filter", selectedFilters);
    if (authBroker?.payload?.user || authIframeBroker?.payload?.user) {
      if (
        (authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate) &&
        false
      ) {
        if (selectedFilters.clickedApply) {
          if (selectedFilters.selectedOfficeList.length == 0) {
            setIsLoading(false);
            setConfirmModal(true);
          } else {
            setCounter(1);
            setOfficeCounter(1);
            setManagerCounter(1);
            setOfficeIds(
              selectedFilters.selectedOfficeList.map((obj) => {
                console.log("GET OFFICE IDS get", obj);
                return obj.office_id;
              })
            );

            setReaIds(
              selectedFilters.selectedTeamMatesList.map((obj) => {
                return obj.user_id;
              })
            );

            setManagerIds(
              selectedFilters.selectedManagerCoachList.map((obj) => {
                return obj.id;
              })
            );

            setRole(selectedFilters.selectedRole);
            setStatusAPI(selectedFilters.selectedStatus);
            setdojRange(selectedFilters.dojRange);
            setIsLoading(true);
            getTableReport();
          }
        } else {
          setIsLoading(false);
          setUsageReports([]);
        }
      } else if (
        (!_.isEmpty(selectedFilters) && !filterId) ||
        selectedFilters?.clickedApply
      ) {
        setCounter(1);
        setOfficeCounter(1);
        setManagerCounter(1);
        setOfficeIds(
          selectedFilters.selectedOfficeList.map((obj) => {
            console.log("GET OFFICE IDS get", obj);
            return obj.office_id;
          })
        );

        setReaIds(
          selectedFilters.selectedTeamMatesList.map((obj) => {
            return obj.user_id;
          })
        );

        setManagerIds(
          selectedFilters.selectedManagerCoachList.map((obj) => {
            return obj.id;
          })
        );
        setSurveyIds(
          selectedFilters?.selectedSurveyList?.map((obj) => {
            return obj.id;
          })
        );
        setLpSurveyIds(
          selectedFilters?.selectedCourseList?.map((obj) => {
            return obj.id;
          })
        );
        setRole(selectedFilters.selectedRole);
        setStatusAPI(selectedFilters.selectedStatus);
        setdojRange(selectedFilters.dojRange);
        setIsLoading(true);
      }
    }
  }, [selectedFilters, authBroker]);

  useEffect(() => {
    //   console.log("ss-- change");
    if (
      ((!filterId || selectedFilters?.clickedApply) &&
        (authBroker.payload?.user || authIframeBroker.payload?.user) &&
        !(
          authBroker.payload?.user?.is_corporate ||
          authIframeBroker.payload?.user?.is_corporate
        )) ||
      true
    ) {
      loadAllApi();
    }
  }, [reaIds, officeIds, statusAPI, Role]);

  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }
  const [usageReports, setUsageReports] = useState([]);
  const [usageReportsFilter, setusageReportsFilter] = useState([]);

  // const currentTableData = useMemo(() => {
  //   if (usageReports !== null) {
  //     const firstPageIndex = (currentPage - 1) * PageSize;
  //     const lastPageIndex = firstPageIndex + PageSize;
  //     setCanShow(true);
  //     return usageReports.slice(firstPageIndex, lastPageIndex);
  //   }
  // }, [currentPage, usageReports]);

  const currentTableData = useMemo(() => {
    if (!_.isEmpty(usageReports)) {
      return usageReports;
    }
  }, [currentPage, usageReports]);

  useEffect(() => {
    console.log("check----", usageReportRes);
    if (!_.isEmpty(usageReportRes)) {
      if (usageReportRes?.status === "success") {
        setIsLoading(false);
        const usageReport = usageReportRes?.payload?.payload?.listing;
        setUsageReports(usageReport);
        setTotalRecords(usageReportRes?.payload?.payload?.total_records);
        setusageReportsFilter(usageReport);
        setProfileReports(usageReportRes?.payload?.payload);
        setCurrentPage(1);
      } else {
        setUsageReports([]);
        setIsLoading(false);
        setCanShow(false);
      }
      dispatch(getLearningPathSurveyReportTableDataResClear());
    }
  }, [usageReportRes]);

  const loadAllApi = () => {
    // getREADATA();
    // getTrendData();
    getTableReport();
    // getOfficeData();
    // getManagerData();
    setReaList([]);
  };

  const getTableReport = (page = 0) => {
    let userStatus = 4;
    if (_.isArray(selectedFilters.selectedAgentStatus)) {
      if (
        selectedFilters.selectedAgentStatus.includes(3) ||
        (selectedFilters.selectedAgentStatus.includes(1) &&
          selectedFilters.selectedAgentStatus.includes(2))
      ) {
        userStatus = 3;
      } else if (selectedFilters.selectedAgentStatus.includes(1)) {
        userStatus = 1;
      } else if (selectedFilters.selectedAgentStatus.includes(2)) {
        userStatus = 2;
      }
    }
    setUserStatusFilter(userStatus);
    dispatch(
      getLearningPathSurveyReportTableData({
        module: "lpSurveyReportTable",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: reaIds,
          office_ids: officeIds,
          manager_ids: managerIds,
          role: Role,
          search: searchInput ? searchInput : "",
          page: page ? page : pageNum ? pageNum : 1,
          page_size: pageSize,
          date_range: dojRange,
          user_status: userStatus,
          survey_status: selectedFilters?.selectedStatus,
          lp_ids: lpSurveyIds,
          brokerage: [],
          sortBy: "asc",
          assigner_role: ["self"],
          survey_ids: surveyIds,
        },
      })
    );
  };

  const getOfficeData = () => {
    // GET OFFICE DATA
    dispatch(
      getCoeOffices({
        module: "getCoeReportOffices",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          office_ids: officeIds,
          limit: officeCounter,
          stat: statusAPI,
          rea_ids: reaIds,
          manager_ids: managerIds,
        },
      })
    );
  };

  const getManagerData = () => {
    // GET MANAGER DATA
    dispatch(
      getCoeManagers({
        module: "getCoeReportManagers",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: managerCounter,
          office_ids: officeIds,
          stat: statusAPI,
          rea_ids: reaIds,
          manager_ids: managerIds,
        },
      })
    );
  };

  function formatDate(inputDate) {
    const dateParts = inputDate.split("/");

    // Check if the date format is valid
    if (dateParts.length !== 3) {
      return "";
    }

    const formattedDate = new Date(
      `${dateParts[2]}-${dateParts[0]}-${dateParts[1]}`
    );

    if (isNaN(formattedDate.getTime())) {
      return "";
    }

    const day = formattedDate.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthIndex = formattedDate.getMonth();
    const year = formattedDate.getFullYear();

    const formattedString = `${day} ${monthNames[monthIndex]}, ${year}`;

    return formattedString;
  }

  useEffect(() => {
    if (pageNum && !isLoading) {
      setIsLoading(true);
      setIsLoading(true);
      getTableReport();
    }
  }, [pageNum, pageSize, searchInput]);

  const ExportToExcel = async () => {
    setIsLoading(true);
    selectedFilters.selectedOfficeList.forEach(function (obj) {
      office_ids.push(obj.office_id);
    });
    selectedFilters.selectedTeamMatesList.forEach(function (obj) {
      rea_ids.push(obj.user_id);
    });
    selectedFilters.selectedManagerCoachList.forEach(function (obj) {
      manager_ids.push(obj.id);
    });
    selectedFilters.selectedProviderList.forEach(function (obj) {
      providerList.push(obj.p_id);
    });
    selectedFilters.selectedCourseList.forEach(function (obj) {
      if (obj.source === "xsel") {
        courseList.push(obj.course_code);
      } else {
        courseList.push(obj.course_id);
      }
    });
    await axios
      .post(
        `${CONFIG.API_URL_BROKER_ADMIN}${API_LIST.API_ROUTES_BROKER.LP_SURVEY_REPORT}`,
        {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          rea_ids: selectedFilters.selectedTeamMatesList.map((r) =>
            _.toNumber(r.user_id)
          ),
          office_ids: selectedFilters.selectedOfficeList.map((o) =>
            _.toNumber(o.office_id)
          ),
          manager_ids: selectedFilters.selectedManagerCoachList.map((m) =>
            _.toNumber(m.id)
          ),
          role: selectedFilters.selectedRole,
          search: "",
          page: "0",
          page_size: pageSize,
          date_range: selectedFilters.dojRange,
          user_status: userStatusFilter,
          survey_status: selectedFilters?.selectedStatus,
          lp_ids: selectedFilters?.selectedCourseList?.map((obj) => {
            return obj.id;
          }),
          brokerage: [],
          sortBy: "asc",
          fetchDetail: true,
          assigner_role: ["self"],
          survey_ids: selectedFilters?.selectedSurveyList?.map((obj) => {
            return obj.id;
          }),
          fetchDetail: true,
        },
        { header: { "Content-Type": "application/json" } }
      )
      .then((response) => {
        if (response.data.status) {
          const userRecords = response.data?.data?.listing;
          if (!_.isEmpty(userRecords)) {
            const data = _.cloneDeep(userRecords);
            console.log(data);
            for (let item of data) {
              item.survey_completion_date = item?.survey_completion_date
                ? moment(item?.survey_completion_date).format("MMM DD, YYYY")
                : "-";
              item.survey_status =
                item?.survey_status === "not-started"
                  ? "Yet to start"
                  : item?.survey_status === "completed"
                  ? "Completed"
                  : item?.survey_status;
            }

            const parser = new DOMParser();

            //for sequencing
            let tempArr = [];
            for (const item of data) {
              let obj = {
                "first name": item.first_name,
                "last name": item.last_name,
                role: item.roles,
                email: item.email,
                office_name: item?.office_name,
                manager: item.manager_name,
                lp_name: item?.lp_name,
                survey_name: item?.survey_name,
                survey_status: item?.survey_status,
                survey_completion_date: item?.survey_completion_date,
              };
              tempArr.push(obj);
            }

            const newThing = [];
            tempArr.map((item) => {
              newThing.push(
                _.mapKeys(item, (value, key) => {
                  switch (key) {
                    case "first name":
                      return "First Name";
                    case "last name":
                      return "Last name";
                    case "role":
                      return "Role";
                    case "email":
                      return "Email";
                    case "office_name":
                      return officeLabel;
                    case "manager":
                      return "Manager";
                    case "lp_name":
                      return "LP Name";
                    case "survey_name":
                      return "Survey Name";
                    case "survey_status":
                      return "Survey Status";
                    case "survey_completion_date":
                      return "Survey Completion Date";
                    default:
                      return;
                  }
                })
              );
            });

            for (let i = 0; i < newThing.length; i++) {
              // arrayObj[i].stroke = arrayObj[i]['key1'];
              delete newThing[i].undefined;
            }

            for (let i = 0; i < data.length; i++) {
              // arrayObj[i].stroke = arrayObj[i]['key1'];
              delete data[i]._id;
            }

            //For mobile
            let tempObj = {
              method: "learningPathSurveyReport",
              report: newThing,
            };

            if (window.callbackHandler != undefined) {
              window.callbackHandler.postMessage(JSON.stringify(tempObj));
            } else if (window.webkit != undefined) {
              if (window.webkit.messageHandlers.callbackHandler != undefined) {
                window.webkit.messageHandlers.callbackHandler.postMessage(
                  JSON.stringify(tempObj)
                );
              }
            }

            const worksheet = XLSX.utils.json_to_sheet(newThing);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
            //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
            let fileNameNew = "LearningPathSurveyReport";
            XLSX.writeFile(workbook, fileNameNew + ".xlsx");
          }
        }
      })
      .finally((res) => {
        setIsLoading(false);
      });
  };

  const searchTable = (searchVal) => {
    console.log("searched value", searchVal);
    let list = _.cloneDeep(usageReportsFilter);
    console.log(list, searchVal);
    if (searchVal === "") {
      setUsageReports(list);
      return;
    }

    let filterBySearch = [];
    for (const item of list) {
      if (
        item?.first_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.last_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.email?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.roles?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.manager_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.lp_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.survey_name?.toLowerCase().includes(searchVal.toLowerCase()) ||
        item?.survey_status?.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        filterBySearch.push(item);
      }
    }
    console.log("filterBySearch: ", filterBySearch);

    setUsageReports(filterBySearch);
  };

  const handleClick = () => {
    window.scrollTo(0, 450);
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header pt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-start mb-4">
              {JSON.parse(backbutton) ? (
                ""
              ) : (
                <button
                  type="button"
                  id="backbtnreport"
                  className="btn btn-primary-complete bckbtn"
                  onClick={() => {
                    dispatch(getSavedFilterDataResponseClearById());
                    let obj = { message: "backButton" };
                    if (isMobile) {
                      window.parent.postMessage(
                        JSON.stringify(obj),
                        CONFIG.API_URL_BROKER_ADMIN
                      );
                    } else {
                      navigate(-1);
                    }
                    if (isAndroid || isIOS) {
                      try {
                        if (window.callbackHandler != undefined) {
                          window.callbackHandler.postMessage("backButton");
                        }
                        if (window.webkit != undefined) {
                          if (
                            window.webkit.messageHandlers.callbackHandler !=
                            undefined
                          ) {
                            window.webkit.messageHandlers.callbackHandler.postMessage(
                              "backButton"
                            );
                          }
                        }
                      } catch (err) {
                        console.log("error in sending message");
                      }
                    }
                  }}
                >
                  Back
                </button>
              )}
            </div>
            <div className="col-md-12">
              <div className="reports-head-main">Reports</div>
            </div>

            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <ReportHeaderComponent
                title={"Learning Path Survey Report"}
                isFilterExpand={isExpand}
                setIsFilterExpand={setIsExpand}
                exportReport={ExportToExcel}
              />
              <ReportExportButtonComponent exportReport={ExportToExcel} />
            </div>
            <div className="col-md-12">
              {isExpand && (
                <ReportFiltersComponent
                  setSelectedFilters={setSelectedFilters}
                  selectedFiltersFromDashboard={
                    savedFiltersDataById?.filter_content
                      ? savedFiltersDataById?.filter_content
                      : ""
                  }
                  setIsExpand={setIsExpand}
                  handleClick={handleClick}
                  isMobile={isMobile}
                  isLp={true}
                  showFilters={showFilters}
                  hideOverDueStatus={true}
                  reportType={"learning_path_survey_report"}
                  setLocalFilters={setLocalFilters}
                  localFilters={localFilters}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <div id="myOnboard" class="center_line"></div>
      <div className="system-usage-table">
        <LPSurveyTableComp
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          getFilteredData={[]}
          lpName={"Onboarding Name"}
          isView={isView}
          setCanShow={setCanShow}
          profileReports={usageReports}
          currentTableData={currentTableData}
          totalRecords={totalRecords}
          type={type}
          message={
            "This section will display the feedback submitted for survey."
          }
          searchTable={searchTable}
          setPageNum={setPageNum}
          pageNum={pageNum}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fetchData={getTableReport}
          isMobile={isMobile}
        />
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={`${
          officeLabel == "Office Name" ? "Office(s)" : officeLabel
        } is mandatory, please select first.`}
        isConfirm={false}
        confirmId={""}
        confirmAction={""}
        isRightIcon={false}
        isMobile={isMobile}
      />
    </>
  );
};

export default LearningPathSurveyReportHomeSection;
